// extracted by mini-css-extract-plugin
export default {"followUpButton":"followUpButton-nPorzMDuDkuKt9p8PFGl"};